import { render, staticRenderFns } from "./articlecomment.vue?vue&type=template&id=4a4a0029&"
import script from "./articlecomment.vue?vue&type=script&lang=js&"
export * from "./articlecomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports